/**
 * Reinitializes Gravity Forms after a Barba.js page transition.
 *
 * GF AJAX forms work by submitting to a hidden iframe (gform_ajax_frame_X).
 * An inline script wraps the iframe load handler inside gform.initializeOnLoaded(),
 * which only executes once the core GF scripts have loaded and set their flags.
 *
 * This function:
 * 1. Cleans up stale GF elements from the old (hidden) Barba container to prevent
 *    duplicate ID conflicts (jQuery would bind to the wrong elements otherwise).
 * 2. Parses and executes GF inline initialization scripts from the new page HTML.
 *
 * Requires the gform_gravityforms_theme script to be enqueued on all pages (see
 * lib/vendor/gravity-forms/functions.php) so gform.initializeOnLoaded() resolves.
 *
 * @param {string} html - The full HTML string of the next page fetched by Barba.
 * @param {boolean} debug
 */
export function refreshGravityForms(html, debug = false) {
    if (!html) return;

    // Only run if Gravity Forms markup is present on the new page
    if (html.indexOf('gform_wrapper') === -1 && html.indexOf('gform_fields') === -1) {
        return;
    }

    if (typeof gform === 'undefined') {
        if (debug) console.warn('Gravity Forms: gform global not found. Ensure gform_gravityforms_theme is enqueued on all pages.');
        return;
    }

    // Clean up GF elements from hidden (old) Barba containers to prevent duplicate
    // ID/name conflicts. With sync:true, both containers exist simultaneously and
    // jQuery ID selectors would match the old (hidden) elements first.
    document.querySelectorAll('[data-barba="container"]').forEach(container => {
        if (container.style.display === 'none') {
            container.querySelectorAll('.gform_wrapper, iframe[name^="gform_ajax_frame"]').forEach(el => {
                el.remove();
            });
            if (debug) console.log('Gravity Forms: Cleaned up stale elements from hidden Barba container.');
        }
    });

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const scripts = doc.querySelectorAll('script');

    scripts.forEach(script => {
        const content = script.textContent;
        // Match Gravity Forms initialization scripts (inline only, not external src)
        if (!script.src && (
            content.includes('gform.initializeOnLoaded') ||
            content.includes('gf_global') ||
            content.includes('gform_post_render') ||
            content.includes('gform_ajax_frame')
        )) {
            try {
                window.eval(content);
                if (debug) console.log('Gravity Forms: Executed inline initialization script.');
            } catch (err) {
                if (debug) console.warn('Gravity Forms: Error executing inline script:', err);
            }
        }
    });
}
